<template>
	<div class="infobox-generic-wrapper" :class="state">
		<div class="information-wrapper">
			<div class="information-title">
				<icon/>
                <div v-html="label"/>
            </div>
			<div class="information-content" v-if="content" v-html="content"/>
            <slot></slot>
		</div>
	</div>
</template>

<script setup>
/* Vue */
import { computed, defineAsyncComponent } from 'vue'

/** props received
@label { String, Number }
@content { String, Number }
@state { String } can be [negative, positive, warning] (default is no state)
*/
const props = defineProps({
	label: [String, Number],
	content: [String, Number],
	state: String
})

const iconsMapper = {
	positive: 'check-line',
	negative: 'error',
	warning: 'warning'
}

const icon = computed(() => {
	const iconSelected = !props.state ? 'info' : iconsMapper[props.state]
    return defineAsyncComponent(() => import('@/assets/icons/' + iconSelected + '.svg?inline'))
})
</script>

<style lang="scss">
.infobox-generic-wrapper {
	width: 100%;
	min-height: 40px;

	padding: 16px;

	flex-direction: column;
	justify-content: center;
	align-items: flex-start;

	border-radius: 8px;
	border: 1px solid var(--secondary-light-1);
	background-color: var(--secondary-light-3);

	.information-wrapper {
		width: 100%;

		.information-title {
			min-height: 16px;

			display: flex;
			flex-direction: row;

			@include H7-Regular;
			line-height: 16px;
			color: var(--secondary-dark-3);

			svg {
				width: 16px;
				height: 16px;

				margin-right: 8px;
				flex-shrink: 0;

				.change-color-fill {
					fill: var(--secondary-dark-3);
				}
			}

			a {
				color: var(--primary);
				text-decoration: underline;
			}
		}

		.information-content {
			margin-top: 8px;
			@include H7-Regular;
			line-height: 16px;
			color: var(--secondary-dark-3);
		}
	}

	&.positive {
		border-color: var(--positive);

		.information-title {
			color: var(--positive);

			svg {
				.change-color-fill {
					fill: var(--positive);
				}
			}
		}
	}

	&.negative {
		border-color: var(--negative);

		.information-title {
			color: var(--negative);

			svg {
				.change-color-fill {
					fill: var(--negative);
				}
			}
		}
	}

	&.warning {
		border-color: var(--warning);

		.information-title {
			color: var(--warning);

			svg {
				.change-color-fill {
					fill: var(--warning);
				}
			}
		}
	}
}
</style>
